import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Col, Container, Row, CardBody, Table, UncontrolledTooltip } from "reactstrap";
import Card from "components/PurpleTheme/Card";
import { Link, useLocation } from "react-router-dom";
import {
    getMsTeamsChannels as onGetMsTeamsChannels,
    deleteMsTeamsChannel as onDeleteMsTeamsChannel
} from "../../store/actions"
import { useDispatch, useSelector } from "react-redux";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

//redux

const MSTeamsList = props => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(onGetMsTeamsChannels());
    }, [onGetMsTeamsChannels]);

    const { msteams } = useSelector(state => ({
        msteams: state.MSTeams.msTeamsChannels
    }));

    //meta title
    document.title = "MSTeams | Temperstack";


    const handleDeleteClick = (id) => {
        const data = {
            id: id
        }
        dispatch(onDeleteMsTeamsChannel(data));
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container>
                    <Row>
                        <Col lg="8">
                            <Breadcrumbs
                                title={"Integrated MS Teams"}
                                breadcrumbItem={"Integrated MS Teams"}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Card>
                            <CardBody>
                                <div className="table-responsive react-table">
                                    <Table bordered hover className="table-purple">
                                        <thead className="table-light table-nowrap">
                                            <tr>
                                                <th>Team Name</th>
                                                <th>Tenant ID</th>
                                                <th>Team ID</th>
                                                <th>Created At</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                msteams.map((msteam, index) => (
                                                    <tr key={index}>
                                                        <td>{msteam.name}</td>
                                                        <td>{msteam.ms_tenant_id}</td>
                                                        <td>{msteam.ms_team_id}</td>
                                                        <td>{msteam.created_at}</td>
                                                        <td>
                                                            <i className="mdi mdi-trash-can font-size-18 text-danger" id="deletetooltip" style={{ cursor: 'pointer' }} onClick={() => handleDeleteClick((msteam?.id))} />
                                                            <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                Delete
                                                            </UncontrolledTooltip>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );

};

MSTeamsList.propTypes = {
    t: PropTypes.any,
    chartsData: PropTypes.any,
    onGetChartsData: PropTypes.func,
};

export default withTranslation()(MSTeamsList);
